import Entity from "../models/Entity";
import entitysType from "../../enums/entitysType";
import { processBgtCounter } from "./processBgtCounter";

const getAdditinalFields = (provider, endpoint) => {
    const additinalFields = {
        providerName: provider?.name,
        providerDescription: provider?.text,
        providerLogo: provider?.logo,
        loginToCourseText: provider?.additionalProperties?.loginToCourseText,
        searchIncludeKeys: provider?.searchIncludeKeys,
        sections: endpoint?.sections,
        endpoints: endpoint?.endpointKey ? [endpoint?.endpointKey] : []
    }
    return additinalFields
}

const processAdditionalProperties = (model, provider, endpoint, metadata) => {
    const drops = {};
    if (!model.picture)
        drops.picture = provider.additionalProperties?.defaultImage;
    if (!model.languages || !model.languages?.length > 0)
        drops.languages = ["he", "ar"]

    const dropFields = [...(provider.additionalProperties?.dropFields || []), ...(endpoint?.dropFields || [])];
    dropFields?.forEach(dropField => {

        const modelValue = model[dropField.filterBy];

        if (
            (model[dropField.filterBy] &&
                (dropField.filterValue.type === "array" && evaluateArrayFilter(dropField.filterValue.value, model[dropField.filterBy])) ||
                (dropField.filterValue.type === "func" && evaluateFuncValue(dropField.filterValue.value, metadata, model)) ||
                (dropField.filterValue.type === "const" && (modelValue?.includes ? modelValue.includes(dropField.filterValue.value) : modelValue === dropField.filterValue.value))
            )
        ) {
            if (dropField.paramValue.type === "const") {
                drops[dropField.paramName] = dropField.paramValue.value;
            }
            if (dropField.paramValue.type === "func") {
                try {
                    // eslint-disable-next-line 
                    const result = evaluateFuncValue(dropField.paramValue.value, metadata, model);
                    drops[dropField.paramName] = result;
                }

                catch (e) {
                    console.error('Error parsing or executing the function:', e);
                }
            }
        }
    });

    return drops;
}

const evaluateArrayFilter = (arrayFilter, modelValue) => {
    return Array.isArray(arrayFilter) && arrayFilter.some(value => modelValue?.includes ? modelValue.includes(value) : modelValue === value);
}

const evaluateFuncValue = (funcValue, metadata, model) => {
    try {
        const func = eval(`(${funcValue})`);
        return func(metadata, model);
    } catch (e) {
        console.error('Error parsing or executing the function:', e);
        return undefined; // Return an appropriate default value or handle the error as needed.
    }
}

const getCourseDomain = (domains) => {
    return domains?.reduce((obj, domain) => {
        obj[domain.name] = domain.color;
        return obj
    }, {});
}

const getNearestEvent = (courseCalendarEvents) => {
    if (courseCalendarEvents) {
        const eventsSorted = courseCalendarEvents.sort((a, b) => new Date(a.from) - new Date(b.from))
        const nearestEvent = eventsSorted.filter(event => new Date(event.from) > new Date())
        return nearestEvent && nearestEvent[0] ? nearestEvent[0] : null
    }
    return null
}

const addCourseCategory = (provider, courseTeachers, addedCoursesWithCategory, selectedTeachers, courseToAdd) => {
    if (addedCoursesWithCategory < 10) {
        const teacherName = courseTeachers && courseTeachers[0] && courseTeachers[0].name;
        if (teacherName && (!selectedTeachers.has(teacherName))) {
            selectedTeachers.add(teacherName);
            addedCoursesWithCategory = addedCoursesWithCategory + 1;
            courseToAdd.category = provider.category;
        }
    }
}

export const processResponse = (responseType, response, endpoint, provider, metadata) => {
    switch (responseType) {
        //only until bgt counters api is ready (wait for api refactor)
        case "bgtCounter":
            return processBgtCounter(response, endpoint, provider, metadata);
        default:
            return processEntity(responseType, response, endpoint, provider, metadata);
    }
}


const processEntity = (responseType, response, endpoint, provider, metadata) => {

    const entitiesList = []
    let addedEntitiesWithCategory = 0;
    const selectedTeachers = new Set();

    response.forEach(entity => {

        const nearestEvent = getNearestEvent(entity.calendarEvents)

        let entityToAdd = {
            ...entity,
            // temp until api refactor
            domain: entity.domains ? entity.domains[0] : null,
            domains: entity.domains,
            tags: entity.tags || endpoint?.tags || provider.tags,
            eventFromDate: nearestEvent ? nearestEvent.from : null,
            eventToDate: nearestEvent ? nearestEvent.to : null,
            type: responseType,
        }

        const entityAdditinalFields = getAdditinalFields(provider, endpoint)
        const dropEntityFields = processAdditionalProperties(entityToAdd, provider, endpoint, metadata);

        entityToAdd = new Entity({
            ...entityToAdd,
            ...entityAdditinalFields,
            ...dropEntityFields
        })

        const sharedDomain = addSharedDomain(entityToAdd, metadata);
        entityToAdd.sharedDomain = sharedDomain;
        const domainsColors = getCourseDomain(metadata.domains)
        entityToAdd.domainColor = domainsColors[entityToAdd.domain];

        addCourseCategory(provider, entity.teachers, addedEntitiesWithCategory, selectedTeachers, entityToAdd)
        if (entityToAdd.calendarEvents) {
            const entityForEntity = entityToAdd.calendarEvents.map(entity => new Entity({
                entityExternalId: entity.id,
                picture: entityToAdd.picture,
                teachers: entityToAdd.teachers,
                domain: entityToAdd.domain,
                sharedDomain: entityToAdd.sharedDomain,
                domainColor: entityToAdd.domainColor,
                ...entityAdditinalFields,
                ...entity,
                link: entity.link || entityToAdd.link,
                type: entitysType.event
            }));
            entitiesList.push(...entityForEntity);
        }

        if (entityToAdd.assessments) {
            const assessmentsForCalendar = entityToAdd.assessments.filter(entity => entity.dueDate).map(entity => new Entity({
                entityExternalId: entity.id,
                picture: entityToAdd.picture,
                teachers: entityToAdd.teachers,
                domain: entityToAdd.domain,
                sharedDomain: entityToAdd.sharedDomain,
                domainColor: entityToAdd.domainColor,
                ...entityAdditinalFields,
                sections: [...(entityToAdd.sections || []), ...(entity.sections || [])],
                title: entity.name,
                description: entity.description || entityToAdd.name,
                date: entity.dueDate,
                allDayEvent: true,
                link: entity.link || entityToAdd.link,
                id: entity.id,
                schoolId: entityToAdd.schoolId,
                isAssessment: true,
                type: entitysType.event
            }));
            entitiesList.push(...assessmentsForCalendar);

            const EntityForEntity = entityToAdd.assessments.map(entity => new Entity({
                entityExternalId: entity.id,
                entityName: entity.name,
                teachers: entityToAdd.teachers,
                domain: entityToAdd.domain,
                domains: entityToAdd.domains,
                domainColor: entityToAdd.domainColor,
                ...entityAdditinalFields,
                ...entity,
                link: entity.link || entityToAdd.link,
                picture: entity.picture || entityToAdd.picture,
                type: entitysType.assessment
            }));
            entityToAdd.assessments = EntityForEntity;
            entitiesList.push(...EntityForEntity);
        }
        entitiesList.push(entityToAdd);
    });

    return { providerName: provider?.name, endpointKey: endpoint?.endpointKey, entitiesList }
}

const addSharedDomain = (model, metadata) => {
    if (model.domain) {
        const domain = metadata.domains.find(d => d.name === model.domain);
        if (domain)
            return domain.sharedDomain ? domain.sharedDomain : domain.name;
    }
    return undefined;
}
